// Static Permissions are permissions that do not need more information, just a yes or no

// Dynamic permissions need to evaluate parameters to see if the permission is allowed, such as cases:edit here

// export const casePermissions = {
//   view: 'cases:view',
//   create: 'cases:create',
//   edit: 'cases:edit',
//   delete: 'cases:delete',
// };

// export const userPermissions = {
//   view: 'users:view',
//   edit: 'users:edit',
//   create: 'users:create',
// };

export const permissions = {
  receiving: 'receiving', //requests for items(anyone)
  transfer: 'transfer', // transfer items (supervisor, admin)
  salvage: 'salvage', // salvage items (supervisor, admin)
  orders: 'orders', //requestedItems updates (receiving supervisor, admin)
  eone: 'eone',
  noAuth: 'noAuth', // for users with no permissions
};

export const rules = {
  Admin: {
    static: [permissions.receiving, permissions.orders, permissions.salvage, permissions.transfer, permissions.eone],
  },
  Receiving: {
    static: [permissions.receiving, permissions.orders, permissions.salvage, permissions.transfer, permissions.eone],
  },
  'Receiving Supervisor': {
    static: [permissions.receiving, permissions.orders, permissions.salvage, permissions.transfer, permissions.eone],
  },
  'Receiving - Capital': {},
  'Receiving Supervisor - Capital': {
    static: [permissions.receiving, permissions.orders, permissions.salvage, permissions.transfer, permissions.eone],
  },
  'Property Coordinator': { 
    static: [permissions.receiving, permissions.orders, permissions.salvage, permissions.transfer, permissions.eone] 
  },
  'Inventory,': {
    static: [permissions.noAuth],
  },
  'Inventory - Capital': {
    static: [permissions.noAuth],
  },
  null: {
    static: [permissions.noAuth],
  },
  /* //template rules, example of dynamic permissions
 viewer: {
    static: [permissions.receiving],
  },
  inspector: {
    static: [casePermissions.view, casePermissions.create],
    dynamic: {
      'cases:edit': ({ userId, caseCreatorId }: any) => {
        if (!userId !== caseCreatorId) return false;
        return userId === caseCreatorId;
      },
      //import { propTypes } from 'react-bootstrap/esm/Image';
    },
  },
  admin: {
    static: [
      // Case Permissions
      casePermissions.view,
      casePermissions.create,
      casePermissions.edit,
      casePermissions.delete,

      // User permissions
      userPermissions.view,
      userPermissions.edit,
      userPermissions.create,
    ],
  },*/
};
